import axios from '../axios';
// 服务费列表
export const getSysFeePage = data => {
  return axios({
    url: '/api/sys/fee/getSysFeePage',
    method: 'post',
    data
  })
};
// 服务费列表（保存）
export const saveSysFee = data => {
  return axios({
    url: '/api/sys/fee/saveSysFee',
    method: 'post',
    data
  })
};
// 服务费列表（修改）
export const updateSysFee = data => {
  return axios({
    url: '/api/sys/fee/updateSysFee',
    method: 'post',
    data
  })
};
// 服务费列表（审核服务费）
export const auditSysFee = data => {
  return axios({
    url: '/api/sys/fee/auditSysFee',
    method: 'post',
    data
  })
};
// 服务费列表（删除）
export const deleteSysFees = data => {
  return axios({
    url: '/api/sys/fee/deleteSysFees',
    method: 'post',
    data
  })
};
// 服务费列表（禁用/启用）
export const forbidSysFees = data => {
  return axios({
    url: '/api/sys/fee/forbidSysFees',
    method: 'post',
    data
  })
};
// 服务费列表（取消审核服务费）
export const unAuditSysFee = data => {
  return axios({
    url: '/api/sys/fee/unAuditSysFee',
    method: 'post',
    data
  })
};

// 组织付费记录列表
export const getSysTissueChargePage = data => {
  return axios({
    url: '/api/sys/sys/getSysTissueChargePage',
    method: 'post',
    data
  })
};
// 保存组织付费记录
export const saveSysTissueCharge = data => {
  return axios({
    url: '/api/sys/sys/saveSysTissueCharge',
    method: 'post',
    data
  })
};
// 修改组织付费记录
export const updateSysTissueCharge = data => {
  return axios({
    url: '/api/sys/sys/updateSysTissueCharge',
    method: 'post',
    data
  })
};
// 删除组织付费记录
export const deleteSysTissueCharges = data => {
  return axios({
    url: '/api/sys/sys/deleteSysTissueCharges',
    method: 'post',
    data
  })
};
// 组织付费记录（付款状态）
export const paymentSysTissueCharges = data => {
  return axios({
    url: '/api/sys/sys/paymentSysTissueCharges',
    method: 'post',
    data
  })
};
// 组织付费记录（提交）
export const submitSysTissueCharges = data => {
  return axios({
    url: '/api/sys/sys/submitSysTissueCharges',
    method: 'post',
    data
  })
};
// 组织付费记录（开通）
export const auditSysTissueCharges = data => {
  return axios({
    url: '/api/sys/sys/auditSysTissueCharges',
    method: 'post',
    data
  })
};



// 组织付费凭证列表
export const getSysTissueFeePage = data => {
  return axios({
    url: '/api/sys/sys/getSysTissueFeePage',
    method: 'post',
    data
  })
};
// 组织付费凭证列表(保存)
export const saveSysTissueFee = data => {
  return axios({
    url: '/api/sys/sys/saveSysTissueFee',
    method: 'post',
    data
  })
};
// 组织付费凭证续期明细列表
export const getSysTissueFeeDetailPage = data => {
  return axios({
    url: '/api/sys/sys/getSysTissueFeeDetailPage',
    method: 'post',
    data
  })
};
// 公司列表分页
export const getBaseCompanyPage = data => {
  return axios({
    url: '/api/sys/base/company/getBaseCompanyPage',
    method: 'post',
    data
  })
};
// 公司列表新增
export const saveBaseCompany = data => {
  return axios({
    url: '/api/sys/base/company/saveBaseCompany',
    method: 'post',
    data
  })
};
// 公司列表修改
export const updateBaseCompany = data => {
  return axios({
    url: '/api/sys/base/company/updateBaseCompany',
    method: 'post',
    data
  })
};
// 公司列表删除
export const deleteBaseCompanys = data => {
  return axios({
    url: '/api/sys/base/company/deleteBaseCompanys',
    method: 'post',
    data
  })
};
// 办事处列表分页
export const getMeterFactoryPage = data => {
  return axios({
    url: '/api/sys/meter/factory/getMeterFactoryPage',
    method: 'post',
    data
  })
};
// 办事处列表新增
export const saveMeterFactory = data => {
  return axios({
    url: '/api/sys/meter/factory/saveMeterFactory',
    method: 'post',
    data
  })
};
// 办事处列表修改
export const updateMeterFactory = data => {
  return axios({
    url: '/api/sys/meter/factory/updateMeterFactory',
    method: 'post',
    data
  })
};
// 办事处列表删除
export const deleteMeterFactorys = data => {
  return axios({
    url: '/api/sys/meter/factory/deleteMeterFactorys',
    method: 'post',
    data
  })
};
// 外购点列表分页
export const getMeterFactoryAreaPage = data => {
  return axios({
    url: '/api/sys/meter/factory/area/getMeterFactoryAreaPage',
    method: 'post',
    data
  })
};
// 外购点列表新增
export const saveMeterFactoryArea = data => {
  return axios({
    url: '/api/sys/meter/factory/area/saveMeterFactoryArea',
    method: 'post',
    data
  })
};
// 外购点列表修改
export const updateMeterFactoryArea = data => {
  return axios({
    url: '/api/sys/meter/factory/area/updateMeterFactoryArea',
    method: 'post',
    data
  })
};
// 外购点列表删除
export const deleteMeterFactoryAreas = data => {
  return axios({
    url: '/api/sys/meter/factory/area/deleteMeterFactoryAreas',
    method: 'post',
    data
  })
};
// 用户外购点列表
export const getSysUserAreaPage = data => {
  return axios({
    url: '/api/sys/sys/user/area/getSysUserAreaPage',
    method: 'post',
    data
  })
};
// 用户外购点列表新增
export const saveSysUserArea = data => {
  return axios({
    url: '/api/sys/sys/user/area/saveSysUserArea',
    method: 'post',
    data
  })
};
// 用户外购点列表修改
export const updateSysUserArea = data => {
  return axios({
    url: '/api/sys/sys/user/area/updateSysUserArea',
    method: 'post',
    data
  })
};
//一次称重
export const saveArriveWeightWeb = data => {
  return axios({
    url: '/api/sys/meter/meterWayCar/saveArriveWeightWeb',
    method: 'post',
    data
  })
};
//二次称重
export const saveSecondWeightWeb = data => {
  return axios({
    url: '/api/sys/meter/weight/saveSecondWeightWeb',
    method: 'post',
    data
  })
};
//流程表列表
export const getActProcessPage = data => {
  return axios({
    url: '/api/sys/act/process/getActProcessPage',
    method: 'post',
    data
  })
};
//流程表列表保存
export const saveActProcess = data => {
  return axios({
    url: '/api/sys/act/process/saveActProcess',
    method: 'post',
    data
  })
};
//流程表列表修改
export const updateActProcess = data => {
  return axios({
    url: '/api/sys/act/process/updateActProcess',
    method: 'post',
    data
  })
};
//流程表列表删除
export const deleteActProcess = data => {
  return axios({
    url: '/api/sys/act/process/deleteActProcess',
    method: 'post',
    data
  })
};
//流程表列表状态
export const statusActProcesss = data => {
  return axios({
    url: '/api/sys/act/process/statusActProcesss',
    method: 'post',
    data
  })
};
//流程节点表列表
export const getActProcessNodePage = data => {
  return axios({
    url: '/api/sys/act/process/node/getActProcessNodePage',
    method: 'post',
    data
  })
};
//流程节点表列表新增
export const saveActProcessNode = data => {
  return axios({
    url: '/api/sys/act/process/node/saveActProcessNode',
    method: 'post',
    data
  })
};
//流程节点表列表修改
export const updateActProcessNode = data => {
  return axios({
    url: '/api/sys/act/process/node/updateActProcessNode',
    method: 'post',
    data
  })
};
//流程节点表列表删除
export const deleteActProcessNodes = data => {
  return axios({
    url: '/api/sys/act/process/node/deleteActProcessNodes',
    method: 'post',
    data
  })
};
//流程实例表列表
export const getActProcessInstancePage = data => {
  return axios({
    url: '/api/sys/act/process/instance/getActProcessInstancePage',
    method: 'post',
    data
  })
};
//审批流程实例明细列表
export const getActProcessEntryPage = data => {
  return axios({
    url: '/api/sys/act/process/entry/getActProcessEntryPage',
    method: 'post',
    data
  })
};
//审批流程实例明细审核
export const approval = data => {
  return axios({
    url: '/api/sys/act/process/approval',
    method: 'post',
    data
  })
};
//查询已办列表
export const getDonePage = data => {
  return axios({
    url: '/api/sys/act/process/instance/getDonePage',
    method: 'post',
    data
  })
};
//主页待办统计
export const getProcessStatistic = data => {
  return axios({
    url: '/api/sys/act/process/instance/getProcessStatistic',
    method: 'post',
    data
  })
};
//周报配置表列表
export const getWeeklyConfigPage = data => {
  return axios({
    url: '/api/sys/weekly/config/getWeeklyConfigPage',
    method: 'post',
    data
  })
};
//周报配置表列表新增
export const saveWeeklyConfig = data => {
  return axios({
    url: '/api/sys/weekly/config/saveWeeklyConfig',
    method: 'post',
    data
  })
};
//周报配置表列表修改
export const updateWeeklyConfig = data => {
  return axios({
    url: '/api/sys/weekly/config/updateWeeklyConfig',
    method: 'post',
    data
  })
};
//周报配置表列表删除
export const deleteWeeklyConfigs = data => {
  return axios({
    url: '/api/sys/weekly/config/deleteWeeklyConfigs',
    method: 'post',
    data
  })
};
//根据数据源id查询流程实例
export const getActProcessInstanceByDataSourcesId = data => {
  return axios({
    url: '/api/sys/act/process/instance/getActProcessInstanceByDataSourcesId',
    method: 'post',
    data
  })
};
//大小供应商导入
export const uploadBasePartnerTwo = data => {
  return axios({
    url: '/api/sys/uploadBasePartnerTwo',
    method: 'post',
    data
  })
};

//根据结算单号查询流程实例
export const getActProcessInstanceBySettleNo = data => {
  return axios({
    url: '/api/sys/pur/arrival/getActProcessInstanceBySettleNo',
    method: 'post',
    data
  })
};

//查看供应商历史记录
export const getBasePartnerHistoryPage = data => {
  return axios({
    url: '/api/sys/base/partner/history/getBasePartnerHistoryPage',
    method: 'post',
    data
  })
};

// 园区-充值页配置：保存/替换（首页置顶轮播图/充值页推荐/首页推荐）
export const saveTParkTopup = data => {
  return axios({
    url: '/api/sys/t/park/topup/saveTParkTopup',
    method: 'post',
    data
  })
};

// 园区-充值页配置：批量删除（按 id 列表删除）
export const deleteTParkTopups = data => {
  return axios({
    url: '/api/sys/t/park/topup/deleteTParkTopups',
    method: 'post',
    data
  })
};

// 园区-充值页配置：分页查询
export const getTParkTopupPage = data => {
  return axios({
    url: '/api/sys/t/park/topup/getTParkTopupPage',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/system.js